export const Colors = {
    pink: '#D967A5',
    purple: '#463A8C',
    darkBlue: '#728CBF',
    lightBlue: '#ABDEF1',
    footer: '#45405C',

    // low opacity
    purpleTransparent: "#463a8c86",
}